import { USER_SET_USER } from '../actions/user';

export default function user(state = null, action = {}) {
  switch (action.type) {
    case USER_SET_USER:
      return { ...state, user: action.data.user };

    default:
      return state;
  }
}
